module.exports = __webpack_public_path__ + "img/left_right_layout_4.ba1b262b.png";